// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"91":"9598195f","189":"a49b93c4","242":"fe5cb45c","463":"52badda8","488":"24365143","585":"ca6c539f","588":"cfb5d479","834":"08217412","981":"4f893a66"}[chunkId] + ".chunk.js";
};